import { Environment } from "shared";

const environmentsMap: Record<string, Environment> = {
  localhost: "localhost",
  dev: "dev",
  qa: "qa",
  mo: "mo",
  www: "prod",
  hagerty: "prod",
  sandbox: "dev",
  ci: "qa",
  preprod: "mo",
} as const;

const reInternalNonProd =
  /ap-spa-(dev|qa|mo)-(?:us|ca).member-engagement-non-prod.hagerty.com/;

/**
 * Gets the environment based on the hostname.
 * @param hostname The value of window.location.hostname
 * @returns The environment
 */
export const getEnvironment = (hostname: string): Environment => {
  // This will try to match on internal non-prod tenancy hostnames like "ap-spa-dev-us.member-engagement-non-prod.hagerty.com"
  const match = reInternalNonProd.exec(hostname);
  if (match) {
    return environmentsMap[match[1]] as Environment;
  }

  const segments = hostname.split(".");

  // Legacy format: account.{env}.hagerty.com
  // Unified Edge format: {env}.hagerty.com
  const environmentKey = segments[0] === "account" ? segments[1] : segments[0];

  const environment = environmentsMap[environmentKey];
  if (!environment) {
    throw new Error(
      `Unknown environment: ${environmentKey} in hostname: ${hostname}`
    );
  }

  return environment;
};
